import React from 'react';
import Logger from '../../util/Logger';
import { connect } from 'react-redux';
import './EmailDelivery.css';
import { StringUtils } from '../../util/StringUtils';
import { showDialog } from '../../actions/dialog';
import { PulseLoader } from 'react-spinners';
import { sendTestEmailDelivery } from '../../actions/emailDelivery';
import { handleEmailErrorsWithDialog, handleErrorWithDialog } from '../../util/Errors';
import User from '../../models/User';
import { BaseDialog } from '../layout/Dialog';
import Tenant from '../../models/Tenant';
import { PAGE_LINK_IT_CHECKLIST, PAGE_LINK_TEST_EMAIL_LEARN_MORE } from '../../constants';
import { EnterpriseSettings } from '../../analytics/EnterpriseSettings';
import { NavigationUtils } from '../../util/NavigationUtils';

class EmailDelivery extends React.Component {

  handleSendButtonClicked = ($event) => {
    $event.preventDefault();

    if (this.isSendDisabled()) {
      // Do nothing when disabled
      return;
    }

    // Split the string into a list
    const emails = StringUtils.stringToList(this.state.testEmails);
    const { user, sendTestEmailDelivery } = this.props;
    if (emails && emails.length > 0) {
      EnterpriseSettings.sendTestEmail();
      sendTestEmailDelivery(Tenant.getId(User.getTenant(user)), emails);
    }

    this.setState({
      testEmails: ''
    });
  };

  handleTestEmailsChanged = ($event) => {
    $event.preventDefault();

    this.setState({
      testEmails: $event.target.value || ''
    });
  };

  handleOnLearnMoreClicked = ($event) => {
    $event.preventDefault();
    EnterpriseSettings.learnMoreTestEmail();
    NavigationUtils.openTab(PAGE_LINK_TEST_EMAIL_LEARN_MORE);
  };

  handleOnBoardingLinkClicked = ($event) => {
    $event.preventDefault();
    EnterpriseSettings.itChecklist();
    NavigationUtils.openTab(PAGE_LINK_IT_CHECKLIST);
  };

  isSendDisabled = () => {
    const { testEmails } = this.state;
    const { loading } = this.props;
    return loading || !testEmails || testEmails.length === 0;
  };

  bonVoyage = (newDelivery, oldDelivery) => {
    if (newDelivery.length > 0 && newDelivery !== oldDelivery && oldDelivery.length === 0) {
      EnterpriseSettings.testEmailEnRouteModal();
      this.setState({ bonVoyage: true });
    }
  };
  hideDialog = () => {
    this.setState({
      bonVoyage: false
    });
  };

  constructor (props) {
    super(props);

    const { user } = this.props;
    if (!user) {
      Logger.assert('EmailDelivery component cannot be used without a User object');
    }

    this.state = {
      testEmails: '',
      bonVoyage: false
    };
  }

  componentDidUpdate (prevProps) {
    const { deliverError, deliverErrors, deliveryEmails } = this.props;
    this.bonVoyage(deliveryEmails, prevProps.deliveryEmails);
    handleErrorWithDialog(deliverError, prevProps.deliverError, 'Unable to deliver test email', {
      helpLink: PAGE_LINK_TEST_EMAIL_LEARN_MORE
    });
    handleEmailErrorsWithDialog(deliverErrors, prevProps.deliverErrors,
      'Unable to deliver test emails', {
        helpLink: PAGE_LINK_TEST_EMAIL_LEARN_MORE
      });
  }

  render () {
    const { testEmails, bonVoyage } = this.state;
    const { loading } = this.props;
    return (
      <div className="card">
        <div className="row no-gutters mb-3">
          <div className="text-title my-auto">
            ENSURE POPin EMAIL DELIVERY &amp; APP ACCESS​
          </div>
        </div>

        <div className="row no-gutters explain">
          In today's world of cybersecurity protection, it's good to be proactive by ensuring POPin email 
          and screens can be accessed by users on your organization's network.
          Please safelist the below domains in your proxies, firewalls, and email systems: ​
        </div>

        <div className="row no-gutters mt-2">
          <ul className="ml-3 explain">
            <li>&bull; All subdomains of popinnow.com (*.popinnow.com)</li>
            <li>&bull; popinnow.com</li>
            <li>&bull; popin.it</li>
          </ul>
        </div>

        <div className="row no-gutters mt-2 explain">Refer to our  
          &nbsp;<a href="/#" onClick={ this.handleOnBoardingLinkClicked }>IT Checklist</a>&nbsp;
          for more guidance.
        </div>

        <div className="row no-gutters mt-3 explain">
          Perform a POPin Email Test: 
          (1) Enter the email addresses of users working on a domain specified during your enterprise account set up.
            If testing with multiple people, use commas (,) to separate addresses.
          (2) Click the Send Emails button.
          (3) Confirm the targeted recipient(s) got the message.
        </div>

        <div className="row mt-3 no-gutters">
          <form
            className="test-emails-form col-lg-9"
            name="testEmails"
            onSubmit={ this.handleSendButtonClicked }>
            <input
              type="text"
              className="pop-input col no-gutters pop-form-control"
              placeholder="Enter email addresses"
              value={ testEmails }
              onChange={ this.handleTestEmailsChanged } />
          </form>
          <div className="col-lg-2 clearfix">
            <button
              type="button"
              className="btn pop-btn float-right"
              disabled={ this.isSendDisabled() }
              onClick={ this.handleSendButtonClicked }>
              { loading
                ? <PulseLoader color="#FFFFFF" size={ 10 } />
                : `Send Emails`
              }
            </button>
          </div>
          <div className="col-lg-1" />
        </div>

        <BaseDialog
          show={ bonVoyage }
          title="Success! Your test POPin email is en route."
          body={ (
            <div>
              An email from hello@e.popinow.com has been sent to each specified recipient. Please confirm receipt of that message.
            </div>
          ) }
          ok="Ok"
          onOk={ this.hideDialog }
          hideDialog={ this.hideDialog }
          autoFocus={ true }
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    loading: state.emailDelivery.loading,
    deliverErrors: state.emailDelivery.errors || [],
    deliverError: state.emailDelivery.error,
    deliveryEmails: state.emailDelivery.emails || []
  };
};

export default connect(mapStateToProps, { showDialog, sendTestEmailDelivery })(EmailDelivery);
